import React from 'react';
import { styled } from "../../../stitches.config";
import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

//import picture1 from '../../../assets/img/natemat/KarolinaLewickaCircle.jpg';
//import picture2 from '../../../assets/img/natemat/Ania.jpg';
//import picture3 from '../../../assets/img/natemat/Alan.jpg';
//import picture4 from '../../../assets/img/natemat/MichalMankowskiCircle.jpg';
//import picture5 from '../../../assets/img/natemat/ElizaMichalikCircle.jpg';
//import picture6 from '../../../assets/img/natemat/AleksandraGersz.jpg';

import picture01 from '../../../assets/img/natemat/columnist-1.jpeg';
import picture02 from '../../../assets/img/natemat/columnist-2.jpeg';
import picture03 from '../../../assets/img/natemat/columnist-3.jpeg';
import picture04 from '../../../assets/img/natemat/columnist-4.jpg';
import picture05 from '../../../assets/img/natemat/columnist-5.jpeg';
import picture06 from '../../../assets/img/natemat/columnist-6.jpeg';

import Heading from "../../../redesign/atoms/Heading.tsx"
import Box from '../Box'

export default props => {
    var settings = {
        infinite: true,
        speed: 500,
        slidesToShow: 6,
        slidesToScroll: 0,
        responsive: [
            {
                breakpoint: 1310,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 996,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    centerPadding: '180px',
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: true,
                    arrows: false,
                }
            },
            {
                breakpoint: 660,
                settings: {
                    centerPadding: '140px',
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: true,
                    arrows: false,
                }
            },
            {
                breakpoint: 560,
                settings: {
                    centerPadding: '120px',
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: true,
                    arrows: false,
                }
            },
            {
                breakpoint: 500,
                settings: {
                    centerPadding: '100px',
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: true,
                    arrows: false,
                }
            },
            {
                breakpoint: 440,
                settings: {
                    centerPadding: '80px',
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: true,
                    arrows: false,
                }
            },
            {
                breakpoint: 400,
                settings: {
                    centerPadding: '60px',
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: true,
                    arrows: false,
                }
            },
            {
                breakpoint: 355,
                settings: {
                    centerPadding: '40px',
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: true,
                    arrows: false,
                }
            },
        ]
    };
    return (
        <Wrapper>
            <section className="container">
                <Heading title="Felietoniści" />
            </section>
            <section className="container container-slider">
                <WrapperSlider >
                    <Slider {...settings}>
                        <Box {...props}
                            id="b1"
                            type="BColumnists"
                            settings={props.settings.b1}
                            name="Karolina Lewicka"
                            src={picture01}
                            dateText={props.settings.b1?.day?.date}
                            dayText="PONIEDZIAŁEK"
                            status={props.settings.b1?.day?.status}
                            blockStatus={props.settings.b1?.status}
                            authorLink="/u/3496,karolina-lewicka"
                        />
                        <Box {...props}
                            id="b2"
                            type="BColumnists"
                            settings={props.settings.b2}
                            name="Anna Dryjańska"
                            src={picture02}
                            dateText={props.settings.b2?.day?.date}
                            dayText="WTOREK"
                            status={props.settings.b2?.day?.status}
                            blockStatus={props.settings.b2?.status}
                            authorLink="/u/2771,anna-dryjanska"
                        />
                        <Box {...props}
                            id="b3"
                            type="BColumnists"
                            settings={props.settings.b3}
                            name="Alan Wysocki"
                            src={picture03}
                            dateText={props.settings.b3?.day?.date}
                            dayText="ŚRODA"
                            status={props.settings.b3?.day?.status}
                            blockStatus={props.settings.b3?.status}
                            authorLink="/u/3445,alan-wysocki"
                        />
                        <Box {...props}
                            id="b4"
                            type="BColumnists"
                            settings={props.settings.b4}
                            name="Konrad Bagiński"
                            src={picture04}
                            dateText={props.settings.b4?.day?.date}
                            dayText="CZWARTEK"
                            status={props.settings.b4?.day?.status}
                            blockStatus={props.settings.b4?.status}
                            authorLink="https://innpoland.pl/u/2871,konrad-baginski"
                        />
                        <Box {...props}
                            id="b5"
                            type="BColumnists"
                            settings={props.settings.b5}
                            name="Eliza Michalik"
                            src={picture05}
                            dateText={props.settings.b5?.day?.date}
                            dayText="PIĄTEK"
                            status={props.settings.b5?.day?.status}
                            blockStatus={props.settings.b5?.status}
                            authorLink="/u/3514,eliza-michalik"
                        />
                        <Box {...props}
                            id="b6"
                            type="BColumnists"
                            settings={props.settings.b6}
                            name="Tomasz Lis"
                            src={picture06}
                            dateText={props.settings.b6?.day?.date}
                            dayText="WEEKEND"
                            status={props.settings.b6?.day?.status}
                            blockStatus={props.settings.b6?.status}
                            authorLink="/blogi/tomaszlis"
                        />
                    </Slider>
                </WrapperSlider>
            </section>
        </Wrapper>
    );
}

const Wrapper = styled("div", {
    ".style--": {
        marginBottom: "15px",
        "@bp4": {
            marginBottom: "30px"
        }
    },
    ".container-slider": {
        "@media (max-width: 768px)": {
            width: "auto",
            padding: "0"
        }
    }
});

const WrapperSlider = styled("div", {
    ".slick-slide": {
        position: "relative"
    },
    ".slick-track": {
        paddingTop: "10px"
    },
    ".slick-slide.slick-center .Main_wrap__260iu img, .slick-slide.slick-center a": {
        transform: "scale(1.1)",
        transition: "transform 500ms"
    },
    ".slick-slide .Main_wrap__260iu img, .slick-slide a": {
        transition: "transform 300ms",
        width: "inherit",
        objectFit: "cover"
    },
    ".slick-list": {
        paddingTop: "0px !important",
        paddingBottom: "30px !important",
        "@mobile": {
            ".slick-slide > div": {
                margin: "0 10px"
            }
        }
    },
    ".slick-arrow:before": {
        color: "black"
    }
});